import { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import classes from './UserBookCard.module.css';

const UserBookCard = ({ book }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const openMenuHandler = event => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const closeMenuHandler = () => {
    setAnchorEl(false);
  };

  return (
    <>
      <IconButton
        onClick={openMenuHandler}
        className={classes.moreBtn}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        classes={{ paper: classes.menuContainer }}
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenuHandler}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem
          onClick={closeMenuHandler}
          className={classes.menuItem}
          component="a"
          href={`${process.env.REACT_APP_API_PATH_MAYAHII_URL}/${book.clave}`}
          target="_blank"
        >
          Videocursos
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          component={Link}
          to={`/book/${book.clave}`}
        >
          Ir al libro
        </MenuItem>
      </Menu>
      <Button
        component={Link}
        to={`/book/${book.clave}`}
        className={classes.bookCard}
      >
        <figure className={classes.bookImg}>
          <img
            className={classes.img}
            src={book.imagen_url_edustore}
            alt={book.book}
          />
        </figure>
        <aside className={classes.descriptionContainer}>
          <span className={classes.bookName}>{book.book}</span>
          <span className={classes.bookType}>{book.book_type}</span>
        </aside>
      </Button>
    </>
  );
};

UserBookCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  book: PropTypes.object
};

export default UserBookCard;
